export default "__VITE_ASSET__C6kz1LTx__"